import { FC } from "react";
import "./ChatButton.css";

interface PrivacyChatDisclaimerProps {
  profile: string;
  isChecked: boolean;
  setIsChecked: (val: boolean) => void;
}

interface LocaleContent {
  title: string;
  buttonText: string;
  disclaimerHtml: string;
}

export const localeContentMap: Record<string, LocaleContent> = {
  'US English Chat': {
    title: "Chat - Privacy Policy",
    buttonText: 'Launch Chat',
    disclaimerHtml:
      'We use third parties to help us manage this chat. By clicking “Start Chat” you accept our <a href="https://www.youngliving.com/us/en/company/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and consent to third parties receiving and processing the information you input into the chat interface.',
  },
  'US Spanish Chat': {
    title: "Chat - Política de Privacidad",
    buttonText: 'Iniciar Chat',
    disclaimerHtml:
      'Utilizamos terceros para ayudarnos a administrar este chat. Al hacer clic en "Iniciar Chat", acepta nuestra <a href="https://www.youngliving.com/us/en/company/privacy" target="_blank" rel="noopener noreferrer">Política de Privacidad</a> y da su consentimiento para que terceros reciban y procesen la información que ingresa en la interfaz de chat.',
  },
};

export const PrivacyChatDisclaimer: FC<PrivacyChatDisclaimerProps> = ({ profile, isChecked, setIsChecked }) => {
  const localeContent = localeContentMap[profile];
  if (!localeContent) return null;

  return (
    <div className="checkbox-disclaimer-container">
      <input 
            type="checkbox" 
            id="disclaimerAcceptCheckbox" 
            name="accept"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)} />
          <label
            className="disclaimer"
            htmlFor="disclaimerAcceptCheckbox"
            dangerouslySetInnerHTML={{ __html: localeContent.disclaimerHtml }}
          />
    </div>
  );
};
